module.exports = __webpack_public_path__ + "static/media/web_riviera_bg.9c28445e.jpg";